module.exports = __webpack_public_path__ + "static/media/md-thumbs-up.fc44d85e.svg";